import { createAction } from "@reduxjs/toolkit";

/**
 * Generic action to indicate than an error has occurred in some operation.
 */
export const ErrorOccurredAction = createAction<string>("ERROR_OCCURRED");

export const AcknowledgeNextErrorAction = createAction<void>("ACKNOWLEDGE_NEXT_ERROR");
